import { DatePicker as MuiDatePicker, DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers';
import React, { useState } from 'react'

export default function DatePicker({time, disableFuture = false, onChange, views, format, isDateTime, disabled = false}) {
    const [isOpen, setIsOpen] = useState(false)
    const DateComponent = isDateTime ? MuiDateTimePicker : MuiDatePicker;

    return (
        <DateComponent 
            value={time} 
            disableFuture={disableFuture} 
            onChange={onChange} 
            format={format ?? "DD/MM/YYYY"}
            views={views ?? ['year', 'month', 'day']}
            slotProps={{ 
                textField: { 
                    size: 'small', 
                    onClick: () => {
                        if (!disabled) {
                            setIsOpen(true)
                        }
                    },
                    readOnly: true
                },
                htmlInput: {
                    userSelect: 'none'
                }
            }}
            sx={{
                '.MuiPickersInputBase-root': {
                    userSelect: 'none'
                },
                '.MuiPickersTextField': {
                    userSelect: 'none'
                }
            }}
            
            disabled={disabled}
            open={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
        />
    )
}